// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.info[data-v-577427c6] {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.back[data-v-577427c6] {\n  width: 220px;\n  height: 48px;\n  background: #f2a626;\n  opacity: 1;\n  border-radius: 4px;\n  text-align: center;\n  font-size: 18px;\n  font-family: PingFang SC;\n  font-weight: 400;\n  line-height: 48px;\n  color: #ffffff;\n}\n", ""]);
// Exports
module.exports = exports;
